<div class="container">
	@if (areControlsAvailable()) {
		<button
			type="button"
			(click)="onOpenTutorial()"
			class="tertiary tutorial-button"
		>
			<mat-icon svgIcon="help" />
		</button>
		<button
			type="button"
			(click)="onResetGame()"
			class="tertiary reset-button"
		>
			<mat-icon svgIcon="refresh" />
		</button>
	}
	<gaw-tutorial-overlay />
	@if (isLoading()) {
		<gaw-loading-overlay />
	}
	<gaw-scene />
</div>
